import styled, { css } from 'styled-components';
import { Media } from '../../theme/Media';
export const HeaderTemplateWrapper = styled.div `
  background: ${({ theme }) => theme.colors.grey00_1};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey05_1};
`;
export const FieldsFooter = styled.div `
  display: flex;
  justify-content: space-between;
  &:not(:first-child):not(:empty) {
    margin-top: 10px;
  }
  @media ${Media.smMin} {
    > *:not(:first-child) {
      margin-left: 15px;
    }
  }
  @media ${Media.xsMax} {
    flex-direction: column;
    > *:not(:last-child) {
      margin-bottom: 10px;
    }
  }
`;
export const Fields = styled.div `
  position: absolute;
  top: calc(100% + 14px);
  ${(props) => (props.alignRight ? 'right: 0' : 'left: 0')};
  border-radius: 4px;
  transition:
    opacity 0.15s,
    margin-top 0.15s;
  will-change: margin-top, opacity;
  transform-origin: top right;
  background: ${({ theme }) => theme.colors.grey00_1};
  z-index: 3;
  padding: ${(props) => (props.noPadding ? '0px' : '30px')};
  ${({ theme }) => theme.shadows.small};
  ${({ active }) => active &&
    css `
      transform: scale(1);
      opacity: 1;
      margin-top: 0;
      transition-delay: 0.1s;
    `}
  ${({ active }) => !active &&
    css `
      transform: scale(0);
      margin-top: 25px;
      opacity: 0;
      transition:
        opacity 0.15s,
        margin-top 0.15s,
        transform 0s 0.15s;
    `}
  > *:last-child:not(:first-child):not(:empty) {
    margin-top: 15px;
  }
  @media ${Media.xsMax} {
    padding: 20px;
  }
  min-width: 200px;
`;
export const HeaderFields = styled.div `
  display: flex;
  border: 1px solid ${({ theme }) => theme.colors.grey05_1};
  border-radius: 0 4px 4px 0;
  > * {
    position: relative;
    &:not(:last-child) {
      border-right: 1px solid ${({ theme }) => theme.colors.grey05_1};
    }
    &:last-child {
      &:not(:first-child) {
        border-radius: 0 4px 4px 0;
      }
    }
  }
  [class*='Error__Message-'] {
    position: absolute;
    font-size: 9px;
    bottom: 2px;
    left: 18px;
  }
  @media ${Media.xsMax} {
    flex-direction: column;
    > * {
      border-right: 0;
      &:not(:last-child) {
        border-bottom: 1px solid ${({ theme }) => theme.colors.grey05_1};
      }
    }
  }
`;
export const ToggleIcon = styled.div `
  font-size: 12px;
  margin-left: 20px;
  svg {
    fill: ${(props) => (props.disabled ? props.theme.colors.grey70_1 : 'inherit')};
  }
`;
export const Count = styled.div `
  width: 20px;
  height: 20px;
  background: ${(props) => (props.number === 0 ? props.theme.colors.grey70_1 : props.theme.colors.link100)};
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.grey00_1};
  font-size: 10px;
  border-radius: 2px;
  margin-left: 20px;
  padding: 4px 7px;
`;
export const HeaderLeft = styled.div `
  color: ${(props) => (props.disabled ? props.theme.colors.grey70_1 : 'inherit')};
  display: flex;
  align-items: center;
`;
export const Icon = styled.div `
  font-size: 18px;
  margin-right: 10px;
  display: inline-flex;
  svg,
  path {
    ${(props) => props.disabled &&
    css `
        fill: ${props.theme.colors.grey70_1};
      `}
  }
`;
export const FilterItemHeader = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 20px;
  min-height: 48px;
  position: relative;
  z-index: 2;
`;
export const FilterItemWrapper = styled.div `
  background-color: ${(props) => props.isActive && props.theme.colors.grey01_1};
  position: relative;
  border-left: 1px solid ${({ theme }) => theme.colors.grey05_1};
  display: flex;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  width: 100%;
  &:hover {
    background-color: ${(props) => !props.disabled && props.theme.colors.grey01_1};
  }
  &:last-child {
    border-right: 1px solid ${({ theme }) => theme.colors.grey05_1};
  }
  @media ${Media.smMax} {
    width: 50%;
    &:not(:nth-last-child(-n + 2)) {
      border-bottom: 1px solid ${({ theme }) => theme.colors.grey05_1};
    }
    &:nth-child(2n) {
      border-right: 1px solid ${({ theme }) => theme.colors.grey05_1};
    }
  }
  @media ${Media.mlMax} {
    width: 100%;
    border-right: 1px solid ${({ theme }) => theme.colors.grey05_1};
    border-left: 1px solid ${({ theme }) => theme.colors.grey05_1};
    &:not(:last-child) {
      border-bottom: 1px solid ${({ theme }) => theme.colors.grey05_1} !important;
    }
  }
`;
export const HeaderFiltersWrapper = styled.div `
  display: flex;
  justify-content: stretch;
  @media ${Media.smMax} {
    flex-wrap: wrap;
  }
`;
export const HeaderFiltersContainerWrapper = styled.div `
  background: ${({ theme }) => theme.colors.grey00_1};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey05_1};
`;
